var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.996094C13.0499 0.996094 16.3567 4.19084 16.4958 8.24515L16.5 8.49609V12.5931L17.88 15.7491C17.9491 15.907 17.9847 16.0775 17.9847 16.2499C17.9847 16.9402 17.4251 17.4999 16.7347 17.4999L12 17.5014C12 19.1582 10.6569 20.5014 9 20.5014C7.40232 20.5014 6.09634 19.2524 6.00509 17.6776L5.99954 17.4991L1.27486 17.4999C1.10352 17.4999 0.934013 17.4646 0.776859 17.3964C0.143657 17.1213 -0.146691 16.3851 0.128347 15.7519L1.5 12.594V8.49599C1.50059 4.3412 4.85208 0.996094 9 0.996094ZM10.4995 17.4991L7.5 17.5014C7.5 18.3298 8.17157 19.0014 9 19.0014C9.77969 19.0014 10.4204 18.4065 10.4931 17.6458L10.4995 17.4991ZM9 2.49609C5.67984 2.49609 3.00047 5.17035 3 8.49609V12.9057L1.65602 15.9999H16.3525L15 12.9067L15.0001 8.50895L14.9964 8.28375C14.8853 5.05027 12.2416 2.49609 9 2.49609Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.57d78718ed55efc9d36a31d45d4ec77f.svg";
export { ForwardRef as ReactComponent };